// src/pages/CareerPage.jsx
import Banner from '@/assets/banner/background.webp';
import PageBanner from '@/components/banner/PageBanner';
import CareerCard from '@/components/career/CareerCard';
import { ContainerFluid } from '@/components/container/Container';
import Seo from '@/components/seo/Seo';
import { H3 } from '@/components/ui/typography/Typography';
import { ApiService } from '@/services/api.services';
import { useEffect, useState } from 'react';

function CareerSkeleton() {
  return (
    <div className="animate-pulse rounded-xl border border-gray-200 bg-white p-4">
      <div className="h-96 w-full rounded-lg bg-gray-200 mb-4"></div>
    </div>
  );
}

export default function CareerPage() {
  const [careerList, setCareerList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchCareers = async () => {
      try {
        const res = await ApiService.getJobVacancies();
        const data = res.data || [];
        setCareerList(data);
      } catch (err) {
        console.error('Failed fetch careers:', err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchCareers();
  }, []);

  return (
    <>
      <Seo
        title={`Karir | Berita Abdi Kerta Raharja`}
        description="Kesempatan bergabung bersama kami untuk berkembang dan berkontribusi."
        canonical="https://www.abdikertaraharja.co.id/karir"
      />
      <div>
        <PageBanner
          title="Karir di Koperasi AKR Syariah"
          description="Kesempatan bergabung bersama kami untuk berkembang dan berkontribusi."
          image={Banner}
        />

        <ContainerFluid className="py-10 lg:py-16">
          <H3 className="mb-5">Lowongan Kerja</H3>

          {/* Loading Skeleton */}
          {loading && (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {[1, 2, 3].map((item) => (
                <CareerSkeleton key={item} />
              ))}
            </div>
          )}

          {/* Error */}
          {!loading && error && <p className="text-red-500">Gagal memuat data lowongan kerja.</p>}

          {/* Empty */}
          {!loading && !error && careerList.length === 0 && (
            <p className="text-gray-500">Belum ada lowongan tersedia saat ini.</p>
          )}

          {/* Data */}
          {!loading && !error && careerList.length > 0 && (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {careerList.map((item, index) => (
                <CareerCard key={index} title={item.title} image={item.banner} />
              ))}
            </div>
          )}
        </ContainerFluid>
      </div>
    </>
  );
}
